// src/pages/ClipsPage.jsx
import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import ClipsVideo from '../../components/SaaS/ClipsVideo'; // NEW component
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { fetchUserProfile } from '../../services/api';
import ClipsVideoRandom from '../../components/SaaS/ClipsVideoRandom';

const languageMap = {
  All: null,
  English: 'en',
  Russian: 'ru',
  Arabic: 'ar'
};

const ClipsPage = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [language, setLanguage] = useState(null);

  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => JSON.parse(localStorage.getItem('sidebarCollapsed')) || false
  );

  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', JSON.stringify(sidebarCollapsed));
  }, [sidebarCollapsed]);

  useEffect(() => {
    const token = localStorage.getItem('authToken');

    const loadUserProfile = async () => {
      try {
        const profile = await fetchUserProfile(token);
        setUserProfile(profile);
      } catch (err) {
        console.error('Error fetching user profile:', err);
      }
    };

    loadUserProfile();
  }, []);
  

  return (
    <div className="dashboard-background">
      <div className="container-fluid">
        <div className="d-flex">
          <Sidebar userProfile={userProfile}
            isCollapsed={sidebarCollapsed}
            setIsCollapsed={setSidebarCollapsed}
          />

          <main className="flex-grow-1 px-4" style={{
            minHeight: '80vh',
            marginLeft: sidebarCollapsed ? '60px' : '220px',
            minWidth: 0 // 👈 prevents layout breaking 
          }}>
            <div className="text-center mb-4">
              <img
                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736174973/image-removebg-preview_1_rez4gn.png"
                alt="Logo"
                style={{ width: '100px', height: '100px' }}
              />
              <h1 className="fw-bold d-inline mb-0">Curated Clips</h1>
            </div>

            {/* Language Filter  
                      <div className="mb-3 d-flex justify-content-center gap-2">
                          {['All', 'English', 'Russian', 'Arabic'].map((lang) => (
                              <button
                                  key={lang}
                                  className={`btn ${language === languageMap[lang] ? 'btn-dark' : 'btn-outline-dark'}`}
                                  onClick={() => setLanguage(languageMap[lang])}
                              >
                                  {lang}
                              </button>
                          ))}
                      </div>
            */}
            <div className="mb-5 d-flex justify-content-center gap-2">

            </div>

            {/* Clips feed */}
            <ClipsVideoRandom language={language} />
          </main>
        </div>
      </div>
    </div>
  );
};

export default ClipsPage;
